export default __webpack_public_path__ + "static/media/P620MANC2.3f377d55.pdf";